<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.ctga_cd_codigo }} - {{ $t('name') }} :
								{{ item.ctga_nm_nome }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						width-auto
						style="border-radius: 5px !important; min-width: 65px"
						@click="downloadCSVCategotiaDeArvore()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="tableData"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; flex-direction: column; gap: 0.5rem">
					<InputText
						:label="$t('name') + '*'"
						:value="model.ctga_nm_nome"
						:disabled="disableNomeCategoria"
						@input="model.ctga_nm_nome = $event.toUpperCase()"
					/>
					<InputText
						v-model="model.ctga_ds_descricao"
						:label="$t('description')"
						:disabled="disableDescricao"
					/>
					<RadioButtons
						v-model="model.ctga_tp_valida_dap"
						style="margin-top: 1rem"
						group-name="valida-dap"
						:label="$t('fillingCap') + '*'"
						:options="optionsRadioButton"
					/>
					<RadioButtons
						v-model="model.ctga_tp_valida_ht"
						style="margin-top: 1rem"
						group-name="valida-ht"
						:label="$t('fillingHight') + '*'"
						:options="optionsRadioButton"
					/>
					<Switcher
						v-model="model.ctga_yn_util"
						style="margin-top: 1rem"
						:label="$t('usefulTree') + '*'"
					/>
					<Switcher
						v-model="model.ctga_yn_util_single_trees"
						style="margin-top: 1rem"
						:label="$t('usefulTreeSingleTrees') + '*'"
					/>

					<label>{{ $t('color') }}*</label>
					<div class="flex gap-2 m-2 items-center">
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.ctga_tx_cor === '#ffffff' }"
							:style="{ backgroundColor: '#ffffff' }"
							@click="model.ctga_tx_cor = '#ffffff'"
						/>
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.ctga_tx_cor === '#ffff00' }"
							:style="{ backgroundColor: '#ffff00' }"
							@click="model.ctga_tx_cor = '#ffff00'"
						/>
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.ctga_tx_cor === '#008000' }"
							:style="{ backgroundColor: '#008000' }"
							@click="model.ctga_tx_cor = '#008000'"
						/>
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.ctga_tx_cor === '#ff0000' }"
							:style="{ backgroundColor: '#ff0000' }"
							@click="model.ctga_tx_cor = '#ff0000'"
						/>
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.ctga_tx_cor === '#0000ff' }"
							:style="{ backgroundColor: '#0000ff' }"
							@click="model.ctga_tx_cor = '#0000ff'"
						/>
						<button
							class="ball w-4 h-4 rounded-full m-1"
							:class="{ active: model.ctga_tx_cor === '#800080' }"
							:style="{ backgroundColor: '#800080' }"
							@click="model.ctga_tx_cor = '#800080'"
						/>
						<svg
							class="cursor-pointer text-[#464947]"
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							@click="setting_color = !setting_color"
						>
							<g
								fill="none"
								fill-rule="evenodd"
							>
								<path
									d="M24 0v24H0V0h24ZM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018Zm.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01l-.184-.092Z"
								/>
								<path
									fill="currentColor"
									d="M16 15c1.306 0 2.418.835 2.83 2H20a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H4a1 1 0 1 1 0-2h9.17A3.001 3.001 0 0 1 16 15Zm0 2a1 1 0 1 0 0 2a1 1 0 0 0 0-2ZM8 9a3 3 0 0 1 2.762 1.828l.067.172H20a1 1 0 0 1 .117 1.993L20 13h-9.17a3.001 3.001 0 0 1-5.592.172L5.17 13H4a1 1 0 0 1-.117-1.993L4 11h1.17A3.001 3.001 0 0 1 8 9Zm0 2a1 1 0 1 0 0 2a1 1 0 0 0 0-2Zm8-8c1.306 0 2.418.835 2.83 2H20a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H4a1 1 0 0 1 0-2h9.17A3.001 3.001 0 0 1 16 3Zm0 2a1 1 0 1 0 0 2a1 1 0 0 0 0-2Z"
								/>
							</g>
						</svg>
					</div>
					<div
						v-if="setting_color"
						class="setting_color_new"
					>
						<div class="flex mb-[4px] w-fit flex-col">
							<span class="font-bold">HEX</span>
							<div class="flex items-center gap-1 border border-[#737576] rounded-[4px] px-2">
								<input
									id=""
									v-model="corModel"
									type="text"
									name=""
									class="w-[5.47vw] leading-7 outline-none"
								/>
								<input
									id="hex"
									v-model="corModel"
									type="color"
									class="cursor-pointer"
								/>
							</div>
						</div>
					</div>
					<div
						v-if="corFoiSugerida"
						class="flex items-center gap-2 border-2 rounded p-2 bg-[#C5CBF1] text-[#272728] border-[#6745ED]"
					>
						<i class="fas fa-info-circle text-xl text-[#6745ED]" />
						<p class="font-medium !m-0">
							{{ $t('corSugerida') }}
						</p>
					</div>
				</div>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../../components/Pagination/Pagination'
import RadioButtons from '../../../../components/RadioButtons/RadioButtons'
import Switcher from '../../../../components/Switcher/Switcher'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'

import {
	createCategoriaDeArvore,
	deleteCategoriaDeArvoreByIdList,
	getAllCategoriaDeArvore,
	updateCategoriaDeArvore,
} from '../../../../services/requests/CategoriaDeArvoreRequests'

import validarCategoriaDeArvore from '../../../../validations/CategoriaDeArvoreValidation'

import {
	abreviar as abreviarArvoreUtil,
	desabreviar as desabreviarArvoreUtil,
} from '../../../../constants/Abreviacoes/ArvoreUtilDeCategoriaDeArvore'
import {
	abreviar as abreviarPreenchimento,
	desabreviar as desabreviarPreenchimento,
} from '../../../../constants/Abreviacoes/PreenchimentoDeValidacoesDeCategoriaDeArvore'

import { corDeterministicaDeCategoria } from '../../../../utils/coresDeCategoria'
import {
	classesParaTagDeArvoreUtil,
	classesParaTagDeValidaCamposDAPeHT,
} from '../../../../constants/Tags/Tags'
import { exportarCsv } from '../../../../utils/csvHellpers'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		// Icon,
		// Accordion,
		Button,
		CrudForm,
		CrudTable,
		// DownloadButton,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
		RadioButtons,
		Switcher,
		KebabMenu,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			setting_color: false,
			/**
			 * Indica que a cor exibida no formulário foi sugerida pelo sistema
			 * (registro ainda sem cor cadastrada) e será gravada ao salvar
			 */
			corFoiSugerida: false,
			coresPadrao: {},
			showExclusionAlert: false,
			categoriaPadrao: [
				'REBROTA',
				'CORTADA',
				'MORTA',
				'TORTUOSA',
				'NORMAL',
				'FALHA',
				'DOMINANTE',
				'TRIFURCADA',
				'MULTIFUSTES',
				'BIFURCADA ACIMA',
				'DOMINADA',
				'INCLINADA',
				'QUEBRADA',
				'BIFURCADA',
			],
			intention: {},
			headersSelecionados: [
				'ctga_yn_util',
				'ctga_tp_valida_ht',
				'ctga_tp_valida_dap',
				'ctga_nm_nome',
				'ctga_cd_codigo',
				'ctga_yn_util_single_trees',
				'cor',
			],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				ctga_cd_codigo: '',
				ctga_ds_descricao: '',
				ctga_nm_nome: '',
				ctga_yn_util: false,
				ctga_yn_util_single_trees: false,
				ctga_tp_valida_dap: '',
				ctga_tp_valida_ht: '',
				ctga_tx_cor: '#008000',
			},
			/**
			 * Configuracoes das opcoes dos radio buttons
			 */
			optionsRadioButton: [
				{ label: this.$t('mandatoryFilling'), value: 'C' },
				{ label: this.$t('mandatoryAbsence'), value: 'S' },
				{ label: this.$t('optional'), value: 'O' },
			],
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				prefix: 'CA',
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'ctga_nm_nome',
				tags: {
					ctga_yn_util: classesParaTagDeArvoreUtil,
					ctga_yn_util_single_trees: classesParaTagDeArvoreUtil,
					ctga_tp_valida_dap: classesParaTagDeValidaCamposDAPeHT,
					ctga_tp_valida_ht: classesParaTagDeValidaCamposDAPeHT,
				},
				colorIndicator: ['cor'],
				titleCardPropertie: 'ctga_cd_codigo',
			},

			tableHeaders: [
				{ key: 'ctga_cd_codigo', value: this.$t('code'), isActive: true },
				{ key: 'ctga_nm_nome', value: this.$t('name'), isActive: true },
				{
					key: 'ctga_ds_descricao',
					value: this.$t('description'),
					isActive: false,
				},
				{
					key: 'ctga_tp_valida_dap',
					value: this.$t('dbh_cbh'),
					isActive: true,
				},
				{ key: 'ctga_tp_valida_ht', value: this.$t('ht'), isActive: true },
				{ key: 'ctga_yn_util', value: this.$t('usefulTree'), isActive: true },
				{
					key: 'ctga_yn_util_single_trees',
					value: this.$t('usefulTreeSingleTrees'),
					isActive: true,
				},
				{ key: 'cor', value: this.$t('color'), isActive: true },
			],

			disableNomeCategoria: false,
			disableDescricao: false,
		}
	},
	computed: {
		corModel: {
			get() {
				return this.model.ctga_tx_cor
			},
			set(value) {
				this.model.ctga_tx_cor = value
			},
		},
		/**
		 * Enriquece os itens da listagem com os dados de apresentação.
		 *
		 * A mutação nos próprios itens é intencional: o CrudTable registra a
		 * seleção escrevendo `isCheckedToDelete` na linha que recebe, e
		 * `modelsIdWithCheckedToDelete` lê essa marcação a partir do `modelList`.
		 * Retornar cópias aqui quebraria a exclusão de registros.
		 *
		 * Como esses campos acabam no `model` ao editar, o payload de atualização
		 * os remove (ver `createCategoriaDeArvoreToPut`).
		 */
		tableData() {
			this.modelsToBeShowedAndTotal.items.forEach((categoria) => {
				categoria.cor =
					categoria.ctga_tx_cor || corDeterministicaDeCategoria(categoria.ctga_nm_nome)
				categoria.isBlocked = this.categoriaPadrao.includes(categoria.ctga_nm_nome)
			})
			return this.modelsToBeShowedAndTotal.items
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return (
				this.model.ctga_nm_nome && this.model.ctga_tp_valida_dap && this.model.ctga_tp_valida_ht
			)
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['ctga_cd_codigo']
		getAllCategoriaDeArvore().then((response) => {
			const { result: categoriasDeArvore } = response.data
			categoriasDeArvore.forEach((categoriaDeArvore) => {
				this.formataCategoriaDeArvoreParaCrud(categoriaDeArvore)
			})
			this.modelList = categoriasDeArvore
			this.modelList.sort((a, b) => a.ctga_cd_codigo - b.ctga_cd_codigo)

			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})
	},
	methods: {
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		createCategoriaDeArvoreToPost() {
			return {
				id: uuidv4(),
				ctga_ds_descricao: this.model.ctga_ds_descricao,
				ctga_nm_nome: this.model.ctga_nm_nome.trim(),
				ctga_tp_valida_dap: this.model.ctga_tp_valida_dap,
				ctga_tp_valida_ht: this.model.ctga_tp_valida_ht,
				ctga_yn_util: this.model.ctga_yn_util,
				ctga_yn_util_single_trees: this.model.ctga_yn_util_single_trees,
				ctga_tx_cor: this.model.ctga_tx_cor,
			}
		},

		downloadCSVCategotiaDeArvore() {
			let cabecalhoDoCsvCatArv = [
				'Código',
				'Nome',
				'Descrição',
				'DAP/CAP',
				'HT',
				'Árvore útil',
				'Árvore útil(single trees)',
				'Cor',
			]
			const items = this.modelList

			const linhas = items.map((item) => [
				item.ctga_cd_codigo,
				item.ctga_nm_nome,
				item.ctga_ds_descricao,
				item.ctga_tp_valida_dap,
				item.ctga_tp_valida_ht,
				item.ctga_yn_util,
				item.ctga_yn_util_single_trees,
				item.ctga_tx_cor,
			])

			exportarCsv('export_categoria_arv', cabecalhoDoCsvCatArv, linhas)
		},

		/**
		 * Cria nova categoria de árvore no banco de dados
		 */
		create() {
			const categoriaDeArvore = this.createCategoriaDeArvoreToPost()

			const { isValid, message } = validarCategoriaDeArvore(categoriaDeArvore, this.modelList)

			if (isValid) {
				createCategoriaDeArvore(categoriaDeArvore).then((response) => {
					const { result: categoriaDeArvore, isError } = response.data
					this.disableSaveButton = false

					if (!isError) {
						this.cleanModel()
						this.formataCategoriaDeArvoreParaCrud(categoriaDeArvore)
						this.modelList.unshift(categoriaDeArvore)

						this.showForm = false
						this.emptyValue = ''

						this.reorganizeItens()

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
			} else {
				this.disableSaveButton = false

				this.mutationShowMessage({
					messageTitle: message,
					messageIcon: 'fa fa-times',
					messageType: 'error',
				})
			}
		},

		/**
		 * Cria o objeto que deve ser enviado para o backend na atualização.
		 * Mantém os campos vindos da API e remove os que existem apenas para a
		 * apresentação na listagem.
		 */
		createCategoriaDeArvoreToPut() {
			const categoriaDeArvore = { ...this.model }

			delete categoriaDeArvore.cor
			delete categoriaDeArvore.isBlocked
			delete categoriaDeArvore.isCheckedToDelete

			return categoriaDeArvore
		},

		/**
		 * Atualiza categoria de arvore no banco de dados
		 */
		update() {
			updateCategoriaDeArvore(this.createCategoriaDeArvoreToPut()).then((response) => {
				const { result: categoriaDeArvore, isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					this.formataCategoriaDeArvoreParaCrud(categoriaDeArvore)

					const indexCategoriaDeArvore = this.modelList.map((m) => m.id).indexOf(this.model.id)
					this.$set(this.modelList, indexCategoriaDeArvore, categoriaDeArvore)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('campoPreenchidoIncorretamente'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui categoria de arvore no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(talhao) =>
						this.modelsIdWithCheckedToDelete.includes(talhao.id) &&
						talhao.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deleteCategoriaDeArvoreByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var categoriaDeArvoreOrganizados = existeRegistroComDependencia
						.map(
							(categoriaDeArvore) =>
								`• Categoria: ${categoriaDeArvore.ctga_cd_codigo} - ${categoriaDeArvore.ctga_ds_descricao}`,
						)
						.join('<br/>')
					var message = `<b>${this.$t('atreladasArvoresEProcessamentos')}:</b> <br/><br/> ${categoriaDeArvoreOrganizados}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Abrevia os campos de categoria de arvore
		 */
		abreviarCampos() {
			this.model.ctga_tp_valida_dap = abreviarPreenchimento[this.model.ctga_tp_valida_dap]
			this.model.ctga_tp_valida_ht = abreviarPreenchimento[this.model.ctga_tp_valida_ht]
			this.model.ctga_yn_util = abreviarArvoreUtil[this.model.ctga_yn_util]
			this.model.ctga_yn_util_single_trees =
				abreviarArvoreUtil[this.model.ctga_yn_util_single_trees]
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataCategoriaDeArvoreParaCrud(categoriaDeArvore) {
			categoriaDeArvore.isCheckedToDelete = false

			categoriaDeArvore.ctga_tp_valida_dap =
				desabreviarPreenchimento[categoriaDeArvore.ctga_tp_valida_dap]
			categoriaDeArvore.ctga_tp_valida_ht =
				desabreviarPreenchimento[categoriaDeArvore.ctga_tp_valida_ht]
			categoriaDeArvore.ctga_yn_util = desabreviarArvoreUtil[categoriaDeArvore.ctga_yn_util]
			categoriaDeArvore.ctga_yn_util_single_trees =
				desabreviarArvoreUtil[categoriaDeArvore.ctga_yn_util_single_trees]
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)

			// Registros antigos podem não ter cor cadastrada. Pré-preenche o model
			// com a mesma cor sugerida que a listagem exibe, para que a cor vista
			// no formulário seja exatamente a que será gravada ao salvar.
			this.corFoiSugerida = !this.model.ctga_tx_cor
			if (this.corFoiSugerida) {
				this.model.ctga_tx_cor = corDeterministicaDeCategoria(this.model.ctga_nm_nome)
			}

			if (this.categoriaPadrao.includes(this.model.ctga_nm_nome)) {
				this.disableNomeCategoria = true
				this.disableDescricao = true
			} else {
				this.disableNomeCategoria = false
				this.disableDescricao = false
			}

			this.abreviarCampos()

			this.titleForm = `${this.$t('edit')} ${this.$t('treeCategory')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.model.ctga_tx_cor = '#008000'
			this.corFoiSugerida = false
			this.disableNomeCategoria = false
			this.disableDescricao = false
			this.titleForm = `${this.$t('create')} ${this.$t('treeCategory')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},

		reorganizeItens() {
			this.quantityPerPage = 10
			this.orderTable = ['ctga_cd_codigo']
			getAllCategoriaDeArvore().then((response) => {
				const { result: categoriasDeArvore } = response.data
				categoriasDeArvore.forEach((categoriaDeArvore) => {
					this.formataCategoriaDeArvoreParaCrud(categoriaDeArvore)
				})
				this.modelList = categoriasDeArvore
				this.modelList.sort((a, b) => a.ctga_cd_codigo - b.ctga_cd_codigo)
				this.tableConfiguration.statusTable = this.$t('noRecordFound')
			})
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>
<style scoped>
.ball {
	box-shadow: inset 2px 2px 4px rgba(30, 30, 30, 0.25);
}

.ball.active {
	border: 2px black solid;
}

#hex {
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	border: none;
	background: none;
	border-radius: 50%;
	width: 1.5rem;
	height: 1.7rem;
}

#hex::-webkit-color-swatch {
	border-radius: 50%;
	border: 1px solid gray;
}

#hex::-moz-color-swatch {
	border-radius: 50%;
	border: none;
}
</style>
